import React, { forwardRef, type ComponentProps } from 'react';
import {
  styled,
  LAYOUT,
  POSITION,
  FLEX_CONTAINER,
} from '@mentimeter/ragnar-styled';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { CharacterCountVariantProps } from './CharacterCount.variants';

const FelaCharacterCountWrap = styled('div', {
  displayName: 'CharacterCountWrap',
})(...LAYOUT, ...FLEX_CONTAINER, ...POSITION, 'color', 'kosmosSpacing');

type CharacterCountWrapT = ComponentProps<typeof FelaCharacterCountWrap> & {
  multiline?: CharacterCountVariantProps['multiline'];
};

export const CharacterCountWrap = forwardRef(
  ({ className, multiline, ...props }: CharacterCountWrapT, ref) => {
    const defaultProps = [
      'relative',
      'flex',
      multiline ? 'items-end' : 'items-center',
    ];
    return (
      <FelaCharacterCountWrap
        className={cn(defaultProps, className)}
        {...props}
        ref={ref}
      />
    );
  },
);
